// context/PremiumProvider.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { getIsPremium } from "../apiHandles/user_progress";

const PremiumContext = createContext();

export const PremiumProvider = ({ children }) => {
    const [isPremium, setIsPremium] = useState(() => {
        const cached = localStorage.getItem('ispremium');
        return cached === 'true';
    });

    useEffect(() => {
        const fetchPremiumStatus = async () => {
            const accessToken = localStorage.getItem("access");
            const refreshToken = localStorage.getItem("refresh");

            if (!accessToken && !refreshToken) {
                setIsPremium(false);
                localStorage.setItem('ispremium', 'false');
                return;
            }

            try {
                const premiumStatus = await getIsPremium();
                if (premiumStatus !== null) {
                    setIsPremium(premiumStatus);
                    localStorage.setItem('ispremium', premiumStatus.toString());
                }
            } catch (error) {
                console.error("Error fetching premium status:", error);
            }
        };

        fetchPremiumStatus();
    }, []);

    const refreshPremiumStatus = async () => {
        try {
            const premiumStatus = await getIsPremium();
            if (premiumStatus !== null) {
                setIsPremium(premiumStatus);
                localStorage.setItem('ispremium', premiumStatus.toString());
            }
        } catch (error) {
            console.error("Error refreshing premium status:", error);
        }
    };

    return (
        <PremiumContext.Provider value={{ isPremium, refreshPremiumStatus }}>
            {children}
        </PremiumContext.Provider>
    );
};

export const usePremium = () => {
    const context = useContext(PremiumContext);
    if (!context) {
        throw new Error("usePremium must be used within PremiumProvider");
    }
    return context;
};